
import axios from 'axios';
import { reactive } from 'vue';
import api from '../../api';
import { setRecaptchaV3Challenge } from '../../recaptcha';

const getDefaultState = () => reactive({
    awards: null,
    prizeWon: null,
    instantWin: [],
    stars: 0,
    sweeps: 0,
});

const state = getDefaultState();

const getters = {};

const mutations = {
    addInstantWinPrize (state, { id }) {
        state.instantWin.push(id);
    },

    incrementStars (state, amount = 1) {
        state.stars += amount;
    },

    incrementSweeps (state, amount = 1) {
        state.sweeps += amount;
    },

    updateAwards (state, awards) {
        state.awards = awards;
    },

    updateInstantWin (state, prizeIds) {
        state.instantWin = [...prizeIds];
    },

    updatePrizeWon (state, prizeWon) {
        state.prizeWon = prizeWon;
    },

    updateStars (state, stars) {
        state.stars = stars;
    },

    updateSweeps (state, sweeps) {
        state.sweeps = sweeps;
    },
};

const actions = {
    async getAwards ({ dispatch }) {
        return dispatch('makeCall', {
            type: 'get',
            endpoint: 'awards',
        });
    },

    async awardEvent ({ dispatch }, { event }) {
        const data = {};
        await setRecaptchaV3Challenge({ data, action: 'award' });
        return dispatch('makeCall', {
            endpoint: `awards/events/${encodeURIComponent(event)}:award`,
            data,
        });
    },

    async loadPrizes ({ commit }) {
        try {
            const response = await axios.get(`${api.base}/awards/me/userPrizes`);
            const { prizeIds, starCount } = response.data;

            commit('updateInstantWin', prizeIds);
            commit('updateStars', starCount);
        }
        catch (error) {
            console.error('could not load user prizes', error);
            throw error;
        }
    },

    async loadSweeps ({ commit }) {
        try {
            const response = await axios.get(`${api.base}/awards/userSweeps`);
            const { sweeps } = response.data;

            commit('updateSweeps', sweeps);
        }
        catch (error) {
            console.error('could not load user sweeps', error);
            throw error;
        }
    },

    async play ({ commit, dispatch, state }) {
        const data = {};
        await setRecaptchaV3Challenge({ data, action: 'play' });
        const response = await dispatch('makeCall', {
            endpoint: 'awards/:play',
            data,
        });

        const {
            boosterWon,
            prizeWon,
            playsRemaining,
            sweepsWon,
        } = response.data;

        if (prizeWon?.id) {
            prizeWon.id = prizeWon.id.replaceAll('-', '').toLowerCase();
        }

        if (prizeWon !== undefined) {
            commit('updatePrizeWon', prizeWon);
        }

        return {
            boosterWon,
            playsRemaining,
            prizeWon,
            sweepsWon,
        };
    },

    async makeCall ({ commit }, {
        type = 'post',
        endpoint,
        data,
    }) {
        let response;

        try {
            response = await axios[type](`${api.base}/${endpoint}`, data);
        }
        catch (err) {
            if (err.response?.status === 429) {
                // User was only limited, carry on
                ({ response } = err);
            }
            else {
                console.error(
                    `error making ${endpoint} call`,
                    err.message,
                    err,
                );

                throw err;
            }
        }

        if (response.data?.awards !== undefined) {
            commit('updateAwards', response.data.awards);
        }
        if (response.data?.prizeWon !== undefined) {
            commit('updatePrizeWon', response.data.prizeWon);
        }

        return response;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
